<svelte:options runes={false} />

<script>
  import { minorToMoney } from '../../api/invoices';
  import { formatHours } from '../format.mjs';

  export let bit;
  export let currency;
  export let rates;
  export let hourlyRateMinor;
  export let selected;
  export let onToggle;

  // Only show what this item comes to once the payer has actually chosen a rate.
  // Before that there is no number to show, and rendering $0.00 reads as a price.
  $: hasRate = Number(hourlyRateMinor) > 0;
  $: laborMinor = Math.round(bit.hours * hourlyRateMinor);
  // A boolean from the publication, and omitted entirely when false — an absent
  // line is calmer than a row of zeroes. Since 2026-08-09 (re-audit F1) no
  // per-bit amount reaches this surface at all, not even unrendered.
  $: hasEarlierContributions = !!rates?.hasContributions;
</script>

<label class="bit-card selectable work-row" class:chosen={selected}>
  <input checked={selected} type="checkbox" on:change={onToggle} />
  <span class="work-row-body">
    <span class="work-row-head">
      <strong>{bit.label}</strong>
      <span class="figure work-row-hours">{formatHours(bit.hours)}</span>
    </span>
    {#if bit.description}
      <small>{bit.description}</small>
    {/if}
    <small class="work-row-money">
      {#if hasRate}
        <span class="money">{minorToMoney(laborMinor, currency)}</span> at your rate
      {:else}
        Set your rate below to see what this comes to
      {/if}
      {#if bit.fixedCostMinor}
        · plus <span class="money">{minorToMoney(bit.fixedCostMinor, currency)}</span> in costs
      {/if}
    </small>
    {#if hasEarlierContributions}
      <small class="work-row-history">Other people have already paid toward these hours</small>
    {/if}
  </span>
</label>
